import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { Helmet } from 'react-helmet';

import SearchBar from 'Parts/search/SearchBarContainer';
import PaginationTop from 'Parts/search/PaginationTop';
import ResultTable from 'Parts/search/ResultTable';
import Can from 'Parts/session/components/CanContainer';

import { DEFAULT_PAGER } from 'Parts/search/searchUtils';
import { simpleColumn, dateColumn, actionColumn } from 'Parts/common/columnUtils';

import teamsListPageEN from './locales/TeamsListPage_en.json';
import teamsListPageFR from './locales/TeamsListPage_fr.json';

class TeamsListPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pager: {
        ...DEFAULT_PAGER,
        total: props.pagination.totalResults || 0,
        current: props.pagination.pageNumber || 1,
        pageSize: props.pagination.pageResults || 10
      }
    };

    i18next.addResourceBundle('en', 'TeamsListPage', teamsListPageEN);
    i18next.addResourceBundle('fr', 'TeamsListPage', teamsListPageFR);
  }

  componentDidUpdate(prevProps) {
    // Update the pager with the new total
    let pager;

    if (prevProps.pagination.pageNumber !== this.props.pagination.pageNumber) {
      pager = {
        ...this.state.pager,
        total: this.props.pagination.totalResults || 0,
        current: this.props.pagination.pageNumber || 1,
        pageSize: this.props.pagination.pageResults || 10
      };

      this.setState({ pager });
    }
  }

  componentWillUnmount() {
    this.props.clearSearch();
  }

  handlePaginationChange = pager => {
    this.setState({ pager });
    const pagination = {
      pageResults: pager.pageSize,
      pageNumber: pager.current
    };
    this.props.searchTeams(
      this.props.platformId,
      this.props.search,
      this.props.filters,
      pagination,
      { orderBy: 'addedOn[desc]' },
      true
    );
  };

  handleViewHandler = teams => {
    const { history, locale } = this.props;
    return history.push(`/${locale}/d/campaigns/${teams.campaignId}/teams/${teams.id}`, {
      originIsAll: true
    });
  };

  handleSearch = filters => {
    const pagination = {
      pageResults: this.state.pager.pageSize
    };
    this.props.searchTeams(
      this.props.platformId,
      filters.search,
      filters,
      pagination,
      { orderBy: 'addedOn[desc]' },
      true
    );
  };

  render() {
    const { t, teams, pagination, locale } = this.props;
    const { pager } = this.state;

    return (
      <Layout className="TeamsListPage">
        <Helmet>
          <title>{t('Teams')}</title>
        </Helmet>
        <SearchBar title={t('Teams')} placeholder={t('Search')} onSearch={this.handleSearch} />
        <Can rules={['permissions.platform.team.get']} redirect={`/${locale}/d`}>
          <div className="AdminList">
            <PaginationTop
              totalLabel={total => t('teamsTotal', { count: pagination.totalResults })}
              pager={pager}
              onChange={this.handlePaginationChange}
            />
            <ResultTable
              dataSource={teams || []}
              pagination={pager}
              onChange={this.handlePaginationChange}
              showHeader={true}
              scroll={{ x: true }}
              columns={[
                //simpleColumn(t('Team ID'), 'id', null, true),
                simpleColumn(t('Name'), 'name', null, true),
                dateColumn(t('Created on'), 'addedOn', null, null, false, locale),
                actionColumn(t('Edit'), ['fal', 'edit'], this.handleViewHandler)
              ]}
            />
          </div>
        </Can>
      </Layout>
    );
  }
}

TeamsListPage.propTypes = {
  searchTeams: PropTypes.func.isRequired,
  Teams: PropTypes.array.isRequired
};

TeamsListPage.defaultProps = {
  teams: [],
  pagination: {
    totalResults: 0
  }
};

export default translate('TeamsListPage')(TeamsListPage);
